import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Part Category Name",
    "Part Category Description",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "Engine Block", description:"he main housing of the engine that contains the cylinders, pistons, and crankshaft.",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "Cylinder Head", description:"The top of the engine block that contains the combustion chambers, spark plugs, and valves",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "Pistons", description:"Moving parts that compress the air/fuel mixture in the cylinders.",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Part Category Name": "part_category_name",
    "Part Category Description":"part_category_desc",    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };